module.exports = __webpack_public_path__ + "static/media/spinner.26df5ead.svg";